/** Andel kopplade fordon, avrundat till hela procent. */
export function fleetConnectionShare(connected: number, total: number): number {
  if (!Number.isFinite(connected) || !Number.isFinite(total) || total <= 0) return 0;
  const safeConnected = Math.min(Math.max(connected, 0), total);
  return Math.round((safeConnected / total) * 100);
}
